import { baseURL } from "../utilits/config";
import axios from "axios";

export function addComments(comentData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/addComents",
    headers: {
      "Content-Type": "application/json",
    },
    data: comentData,
  };

  axios(config)
    .then((result) => {
      return callback(result.data);
    })
    .catch((error) => {
      return callback(error);
    });
}

export function getComments(callback) {
  const config = {
    method: "get",
    url: baseURL + "/addComents",
    headers: {},
  };

  axios(config)
    .then((result) => {
      return callback(result.data);
    })
    .catch((error) => {
      return callback(error);
    });
}
export function getCommentByTaskID(id, callback) {
  const config = {
    method: "get",
    url: baseURL + "/getCOmentBYID?id=" + id,
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}
